import { render } from "./HumanizedTokenAmount.vue?vue&type=template&id=3516ca8b"
import script from "./HumanizedTokenAmount.vue?vue&type=script&lang=js"
export * from "./HumanizedTokenAmount.vue?vue&type=script&lang=js"

import "./HumanizedTokenAmount.vue?vue&type=style&index=0&id=3516ca8b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__